let preparedTrack: MediaStreamTrack | null = null

export async function prepareMicrophoneTrack(): Promise<MediaStreamTrack> {
  if (preparedTrack?.readyState === 'live') return preparedTrack
  releaseMicrophoneTrack()
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
    },
    video: false,
  })
  const track = stream.getAudioTracks()[0]
  if (!track) {
    stream.getTracks().forEach(item => item.stop())
    throw new Error('没有检测到可用的麦克风')
  }
  stream.getTracks().forEach(item => {
    if (item !== track) item.stop()
  })
  preparedTrack = track
  return track
}

export function consumeMicrophoneTrack(): MediaStreamTrack | null {
  const track = preparedTrack?.readyState === 'live' ? preparedTrack : null
  preparedTrack = null
  return track
}

export function releaseMicrophoneTrack(): void {
  preparedTrack?.stop()
  preparedTrack = null
}
